export const LibraryAudioData = {
    voiceover: {
        id: 'library-voiceover',
    },
    gesture: {
        samples: [
            { name: 'gesture-ghost1' },
            { name: 'gesture-ghost2' },
            { name: 'gesture-ghost3' },
        ],
        volume: -6,
    },
    scenes: [
        // 0: Library
        {
            name: "Library main",
            background: {
                samplePool: ['library-background'],
                volume: -16,
                fadeInDuration: 2,
                fadeOutDuration: 2,
                loopStart: 0,
                loopEnd: 31950,
            },
        }
    ]
};
